var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live"},[_c('img',{staticClass:"live_icon",attrs:{"src":require("../../assets/img/video_close.png"),"alt":""},on:{"click":_vm.liveClose}}),_c('p',{staticClass:"live_content"},[_vm._v("敬请期待")])])}
var staticRenderFns = []

export { render, staticRenderFns }